// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"AboutUsPage_Overlay__1wD5_","Content":"AboutUsPage_Content__30RSo"};